module.exports = __webpack_public_path__ + "img/passport-correct-frontside.fbfdbcb0.png";